import { NavigationPage } from 'app-components'
import { ReviewingPermissions } from '@/app/components/SurveyObserver/TeslaFleetAuthSurvey'
import { useTeslaFleetAuthRedirect } from '@/app/hooks/useTeslaFleetAuthRedirect'

const MockVehicleResource = {
  id: 1,
  car: {
    display_name: 'Your Tesla',
    car_model: {
      make: 'Tesla',
      model: 'Review Permissions',
      friendly_model: null,
    },
  },
}

function useViewModel() {
  const { redirectToTeslaAuth } = useTeslaFleetAuthRedirect('vehicle')

  const onContinueClick = () => {
    redirectToTeslaAuth()
  }
  return { onContinueClick }
}

export default function PermissionsNotificationStatement() {
  const { onContinueClick } = useViewModel()

  return (
    <NavigationPage
      id="permissions-notification"
      progressBar={{
        completedSteps: 1,
        totalSteps: 2,
      }}
    >
      <NavigationPage.SingleCardContent>
        <ReviewingPermissions
          vehicles={[MockVehicleResource]}
          onContinueClick={onContinueClick}
        />
      </NavigationPage.SingleCardContent>
    </NavigationPage>
  )
}
